import SwiperDesktop from './slider/SwiperDesktop';
import SwiperMobile from './slider/SwiperMobile';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import './Team.scss';
import useViewport from 'hooks/useViewport';

const Team: React.FC = () => {
  const viewport = useViewport();

  return (
    <div className="team centered" id="team">
      <div className="team__container container">
        <ContentFrame title="Team" borders>
          <div className="team__content">
            <SectionTitle className="team__title">
              <span>Meet Our Team</span>
            </SectionTitle>
            <div className="team__box">
              {viewport > 768 ? <SwiperDesktop /> : <SwiperMobile />}
            </div>
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Team;
